import { Modal, Box, Typography } from "@mui/material";
import MyCheckTree from "../../components/myCheckTree";
import MyButton from "../../components/myButton";
import MyLoading from "../../components/myLoading";

const ModalPermissaoUsuario = ({ open, onClose, onFinalizar, permissoes, permissoesDoUsuario, nomeUsuario, submit }) => {

    return (
        <Modal open={open} onClose={onClose}>
        <Box
            sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: {
                xs: "100%",
                sm: "100%",
                md: "50%",
            },
            height: {
                xs: "90%",
                sm: "80%",
                md: "80%",
            },
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 0,
            display: "flex",
            flexDirection: "column",
            }}
        >
            <MyLoading render={submit} />

            {/* Header */}
            <Box sx={{ p: 3, display: "flex", flexDirection:"row" , alignItems: "center"}}>
                <Typography variant="h6" component="h2" sx={{fontWeight:800}} >
                    Usuário: 
                </Typography>
                {""}
                <Typography variant="h6" component="h2" sx={{ ml: 1 }} >
                    {nomeUsuario}
                </Typography>
            </Box>

            {/* Conteúdo com rolagem */}
            <Box sx={{flex: 1,overflowY: "auto",px: 3,pb: 2,}}>
                <Box
                    sx={{
                    border: "1px solid #ccc",
                    borderRadius: 1,
                    padding: 2,
                    minHeight: '200px',
                    }}
                >
                    <MyCheckTree
                        treeData={permissoes}
                        checked={permissoesDoUsuario}
                        hasExpanded={true}
                    />
                </Box>
            </Box>

            {/* Rodapé fixo */}
            <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                borderTop: "1px solid #eee",
                padding: 2,
                px: 3,
            }}
            >
            <MyButton
                onClick={onClose}
                variant="contained"
                text="Voltar"
                color="warning"
            />
            <MyButton
                onClick={onFinalizar}
                variant="contained"
                text="Salvar"
                color="success"
            />
            </Box>
        </Box>
        </Modal>
    )

}


export default ModalPermissaoUsuario